export default class UtilisateurCycleService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar = snackbar;
    }

    creer(creer, captcha) {
        return this.axios.post("/oauth2/utilisateur/cycle/creer", creer, {
            headers: {
                "X-Captcha": captcha.captcha,
                "X-Captcha-Text": captcha.saisie,
            },
        })
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }

    demandeOubli(email, captcha) {
        return this.axios.post("/oauth2/utilisateur/cycle/oubli", {email},  {
            headers: {
                "X-Captcha": captcha.captcha,
                "X-Captcha-Text": captcha.saisie,
            },
        })
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }

    reinitOubli(code,motPasse) {
        return this.axios.put("/oauth2/utilisateur/cycle/oubli", {code,motPasse})
            .then(response => response.data);
    }

    existeReinitMotPasse(code) {
        return this.axios.get(`/oauth2/utilisateur/cycle/oubli?code=${code}`)
        .then(response => response.data);
    }
}
